export const supplier = {
  create_supplier: "Créer un fournisseur",
  form: {
    name: "Nom",
    name_required: "Le nom est requis",

    email: "Email",
    email_required: "L'Email est requis",

    telephone: "Téléphone",
    address: "Adresse",
    role: "Rôle",
    kbis: "KBIS",
    fiscal_doc: "Document fiscal",
    urssaf_doc: "Document URSSAF",
    creating: "Création en cours...",
    submit: "Créer",
    name_placeholder: "Nom du fournisseur",
    email_placeholder: "Email",
    telephone_placeholder: "Numéro de téléphone",
    address_placeholder: "Adresse",
    role_placeholder: "ID du rôle",
    title: "Modifier un fournisseur",
    label_urssaf: "document URSSAF",
    label_kbis: "document KBIS",
    label_fiscal: "document fiscal",
  },
  create_success: "Fournisseur créé avec succès.",
  create_error: "Erreur lors de la création du fournisseur.",

  table: {
    status: "Statut",
    isVerified: "Vérifié",
    createdAt: "Date de création",
  },
  actions: {
    edit: "Modifier",
    consulter: "Consulter",
    disable: "Désactiver",
    enable: "Activer",
  },
  header_title: "Liste des fournisseurs",
  delete_dialog: {
    title: "Confirmer la désactivation",
    description: "Voulez-vous vraiment désactiver ce fournisseur ?",
    cancel: "Annuler",
    submit: "Désactiver",
  },
  delete_success: "Fournisseur désactivé avec succès",
  delete_error: "Erreur lors de la désactivation du fournisseur",
  update: "Valider",
  article: "Articles",
};
